export function getLocalStorageItem(k: string) {
  return localStorage.getItem(k);
}
